export default __webpack_public_path__ + "static/media/hrv_history.7532623b.png";